export const locationCardData = [
  {
    id: "1",
    img: require("../assets/setting/location/location1.png"),
    country: "United Kingdom",
    city: "London",
    employee: "50",
    colon: require("../assets/setting/location/colon.png"),
  },
  {
    id: "2",
    img: require("../assets/setting/location/location2.png"),
    country: "United Kingdom",
    city: "Glasgow ",
    employee: "30",
    colon: require("../assets/setting/location/colon.png"),
  },
  {
    id: "3",
    img: require("../assets/setting/location/location1.png"),
    country: "United Kingdom",
    city: "Manchester",
    employee: "20",
    colon: require("../assets/setting/location/colon.png"),
  },
  {
    id: "4",
    img: require("../assets/setting/location/location1.png"),
    country: "United Kingdom",
    city: "Manchester",
    employee: "20",
    colon: require("../assets/setting/location/colon.png"),
  },
];
export const cityName = ["London", "Glosgow", "Belfast"];
export const countryName = [
  "United kingdom - UK",
  "United States - US",
  "Pakistan - PK",
];
export const timeZoneName = [
  "GMT    Greenwich Mean Time    GMT",
  "UTC    Universal Coordinated Time    GMT",
  "ECT    European Central Time    GMT+1:00",
];
export const calendarName = ["UK Team Calendar", "PK Team Calendar"];
